import { render, staticRenderFns } from "./params-dialog.vue?vue&type=template&id=38ebfe3a&scoped=true&"
import script from "./params-dialog.vue?vue&type=script&lang=js&"
export * from "./params-dialog.vue?vue&type=script&lang=js&"
import style0 from "./params-dialog.vue?vue&type=style&index=0&id=38ebfe3a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ebfe3a",
  null
  
)

export default component.exports